import axios from "axios";

const baseURL = "https://api.linguaworks.com/v1/";

const AUTH_TOKEN = "_mPQ4YzDp_Hw16-8g_VNoBA7-Anp9pcLM9_5E2GIpv0";

axios.defaults.baseURL = baseURL;
axios.defaults.headers.common["X-API-AUTH-TOKEN"] = AUTH_TOKEN;
axios.defaults.headers.common["Content-Type"] = "application/json";

export default {
  convert(toConvert) {
    return axios({
      method: "post",
      url: `transliterate/text/${toConvert.language}`,
      data: {
        text_to_process: toConvert.original
      },
      params: {
        input: toConvert.inputScript,
        output: toConvert.outputScript
      }
    });
  }
};

// Access-Control-Request-Header
